import {
    defineStore,
} from 'pinia'
import {
    useContextStore,
} from '~~/stores/context'
import { PROVIDERS } from '#shared/providers'

export const useForwardEmailStore = defineStore('forward-email', () => {
    const PROVIDER = PROVIDERS.FORWARD_EMAIL

    const domains = ref([])
    const selectedDomains = ref([])

    const contextStore = useContextStore()
    contextStore.registerProvider(PROVIDER)

    const ctx = computed(() => contextStore.getContext(PROVIDER))
    watch(ctx, (newCtx, oldCtx) => {
        if (newCtx?.identityKey !== oldCtx?.identityKey) {
            domains.value = []
            selectedDomains.value = []
        }
    })

    async function fetchDomains() {
        useRequest({
            label: `fetch forward email domains`,
            fetch: () => $fetch('/api/forward-email/domains', {
                method: 'GET',
            }),
            evaluate: ({ domains: d }) => [...d],
            store: (d) => domains.value = d,
            successDetails: (d) => d.length,
        })
    }

    async function createAlias({ domain, name, recipients }) {
        useRequest({
            label: `create forward email alias`,
            fetch: () => $fetch(`/api/forward-email/domains/${domain}/aliases`, {
                method: 'POST',
                body: {
                    name,
                    recipients: [...recipients],
                },
            }),
        })
    }

    function init() {}

    return {
        domains,
        selectedDomains,
        fetchDomains,
        createAlias,
        init,
    }
})
